import { Camera, Plane, Raycaster, Vector2, Vector3 } from 'three';

const AXIS_Z = new Vector3(0, 0, 1);
const _pointer = new Vector2();
const _plane = new Plane();
const _intersection = new Vector3();
const _raycaster = new Raycaster();
/**
 * 获取鼠标在指定 z 平面上的三维坐标
 * @param x offsetX
 * @param y offsetY
 * @param planeZ 目标 z 平面坐标
 * @returns
 */
export function projectMouseToPlane(camera: Camera, x: number, y: number, planeZ: number) {
  _pointer.x = x;
  _pointer.y = y;

  _raycaster.setFromCamera(_pointer, camera);

  _plane.set(AXIS_Z, -planeZ);

  if (_raycaster.ray.intersectPlane(_plane, _intersection)) {
    return _intersection.toArray();
  }
}
